import React from 'react'
import ComplianceHero from '../../components/ComplianceComponents/ComplianceHero'

const Compliance = () => {
  return (
    <div className="my-10 py-10 sm:p-10">
      <ComplianceHero />
    </div>
  )
}

export default Compliance